import React from "react";
//#region types
import { RouteConstants } from "utils/constants";
import { WeekHoursFieldProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
//#region components
import { Profiles } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";
import { LocalizationHelperInstance } from "utils/helpers";
import TimeReportHelperInstance from "components/timeReporting/timeReportHelper";

const WeekHoursField: React.FC<WeekHoursFieldProps> = (props) => {
  const { value, weekDisplayText, monthStart, employeeId, disableLink } = props;

  const weekStartDateLink = React.useMemo(() => {
    const splitedDates = weekDisplayText?.split("-");
    const startDate = splitedDates && splitedDates[0];
    if (monthStart && startDate) {
      const date = new Date(monthStart.getFullYear(), monthStart.getMonth(), Number(startDate));
      return `/TimeReport/Weekly?${RouteConstants.TimeReportingQueryParams.EmployeeId}=${employeeId}&${
        RouteConstants.TimeReportingQueryParams.CurrentDate
      }=${LocalizationHelperInstance.getFormattedDate(date)}`;
    }
  }, [props.weekDisplayText]);

  const formattedValue = value !== undefined ? TimeReportHelperInstance.formatHours(value) : value;

  return (
    <Grid container justifyContent="flex-end" className={clsx(cssExports.weekHoursField)}>
      <Grid item>
        {formattedValue && weekStartDateLink && !disableLink ? (
          <Profiles.CustomLink
            displayText={`${formattedValue} h`}
            link={weekStartDateLink}
            forceReplacingUrl
          ></Profiles.CustomLink>
        ) : formattedValue && formattedValue !== "0" ? (
          `${formattedValue} h`
        ) : (
          "-"
        )}
      </Grid>
    </Grid>
  );
};

export default WeekHoursField;
